import { Table } from 'flowbite-react';
import React from 'react';

interface Props {
	tableData: {
		topic: string;
		score: number;
	}[];
}

const ScorecardTable = ({ tableData }: Props) => {
	return (
		<Table>
			<Table.Head>
				<Table.HeadCell className="bg-gray-100 dark:bg-[#111E2C] dark:text-[#E5FFFF] text-base font-medium">
					<div className="flex justify-between gap-2">
						<div>Topic</div>
						<div className="md:w-[150px]">Score</div>
					</div>
				</Table.HeadCell>
			</Table.Head>
			<Table.Body className="divide-y-[0.5px] dark:divide-[#8F90A6]">
				{tableData.map(d => (
					<Table.Row key={d.topic} className="dark:bg-[#1F2A37] dark:text-[#FAFAFC] text-sm font-normal">
						<Table.Cell className="py-[6px]">
							<div className="flex justify-between gap-2">
								<div>{d.topic}</div>
								<div className="md:w-[150px]">{d.score}</div>
							</div>
						</Table.Cell>
					</Table.Row>
				))}
			</Table.Body>
		</Table>
	);
};

export default ScorecardTable;
